import { Radio, Spin, Tooltip, Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';
import {
    FaRegHandPointer,
    FaExpandAlt,
    FaUndo,
    FaEye,
    FaDownload,
    FaExchangeAlt,
} from 'react-icons/fa';
import TransferOwnership from './TransferOwnership';
import PageMangerModel from '../pagemanger/PageMangerModel';
import { useState } from 'react';
import Button from '../Globle/Button';

export const HeaderButtons = observer(() => {
    const {
        closetManager,
        drawingManager,
        viewManager,
        apiManager,
        matrixManager,
    } = useMainContext();
    const [isOpen, setIsOpen] = useState(false);
    const isDisabled = !viewManager.doUserHasAccess();

    const buttons = [
        // {
        //     id: '8',
        //     tooltip: 'Fit to Screen',
        //     onClick: async () => {
        //         if (viewManager.selectedMenu === 2) {
        //             await closetManager.fitToScreen();
        //             await closetManager.fitToScreen();
        //         }
        //         if (viewManager.selectedMenu === 3) {
        //             await matrixManager.fitToScreen();
        //         }
        //     },
        //     icon: <FaExpandAlt />,
        // },
        // {
        //     id: '8',
        //     tooltip: 'Reset Unit Table Position',
        //     onClick: () => {
        //         matrixManager.resetUnitTablePosition();
        //     },
        //     icon: <FaUndo />,
        // },
    ];

    const getButtonStyles = (isActive) => ({
        backgroundColor: isActive ? '#F46147' : '#CCCCCC',
        color: isActive ? '#fff' : '#000',
        transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
    });

    const getActiveTooltip = (id) => {
        if (
            id === '1' &&
            drawingManager.isDrawingModeOn &&
            closetManager.units.length > 0
        ) {
            return true;
        }
        if (id === '7' && closetManager.showSnapPoints) {
            return true;
        }
        if (id === '9' && viewManager.isDropDownOpen) {
            return true;
        }
        return false;
    };

    return (
        <>
            <div className="flex gap-2 relative items-center">
                {isDisabled && (
                    <Button
                        disabled={!viewManager.superAdmin}
                        iconClass="!text-[24px] !ml-0 !mr-1 mb-[3px]"
                        icon={FaEye}
                        label="View Only"
                        onClick={() => {
                            if (!viewManager.superAdmin) return;
                            setIsOpen(true);
                        }}
                        className="w-fit !h-[40px] !py-[8px] rounded-[8px] flex items-center justify-center bg-theme-header-bg text-[16px] font-[700] hover:bg-theme-button-bg hover:text-black"
                    />
                )}
                {!viewManager.doUserHasAccess() && viewManager.superAdmin && (
                    <button
                        onClick={() => {
                            Modal.confirm({
                                title: (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px',
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            color: '#1c1c1c',
                                            paddingBottom: '4px',
                                            borderBottom: '1px solid #cccccc',
                                        }}>
                                        Get Page Access
                                    </div>
                                ),
                                icon: null,
                                content: (
                                    <div
                                        style={{
                                            padding: '12px 0',
                                            lineHeight: '1.6',
                                        }}>
                                        <div
                                            style={{
                                                background: '#fff7e6',
                                                border: '1px solid #ffd591',
                                                borderRadius: '8px',
                                                padding: '16px',
                                                marginBottom: '12px',
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: '12px',
                                            }}>
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        color: '#d4380d',
                                                        marginBottom: '8px',
                                                    }}>
                                                    Are you sure you want to
                                                    assign access to this page
                                                    for yourself?
                                                </div>
                                                <div
                                                    style={{
                                                        color: '#8c8c8c',
                                                        fontSize: '14px',
                                                    }}>
                                                    This action will give you
                                                    access to the current page
                                                    and will take access from
                                                    the current owner.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ),
                                width: 480,
                                centered: true,
                                padding: '0px',
                                okText: (
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontWeight: 500,
                                        }}>
                                        Yes, Take
                                    </span>
                                ),
                                cancelText: (
                                    <span style={{ fontWeight: 500 }}>
                                        Cancel
                                    </span>
                                ),
                                okButtonProps: {
                                    size: 'large',
                                    type: 'primary',
                                    className: 'confirm-modal-button',
                                    style: {
                                        background: '#F46147',
                                        border: 'none',
                                        fontWeight: 500,
                                        height: '40px',
                                        borderRadius: '6px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    },
                                },
                                cancelButtonProps: {
                                    size: 'large',
                                    className: 'confirm-modal-button',
                                    style: {
                                        fontWeight: 500,
                                        height: '40px',
                                        borderRadius: '6px',
                                        border: 'none',
                                        color: '#1C1C1E',
                                        backgroundColor: '#E5E5E5',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    },
                                },
                                onOk: async () => {
                                    viewManager.swapPageAccess();
                                    await apiManager.assignPageAccess();
                                },
                                onCancel: () => {},
                                styles: {
                                    padding: '0px',
                                },
                                maskClosable: false,
                                keyboard: true,
                            });
                        }}
                        className="h-[32px] w-fit border-[1px] border-theme-button-bg p-[4px] px-[12px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white flex items-center gap-2">
                        Get Page Access
                    </button>
                )}
                <Button
                    disabled={!viewManager.superAdmin}
                    label="Page Manager"
                    onClick={() => {
                        if (!viewManager.superAdmin) return;
                        setIsOpen(true);
                    }}
                    className="w-fit !h-[40px] !py-[8px] rounded-[8px] flex items-center justify-center bg-theme-header-bg text-[16px] font-[700] hover:!bg-theme-button-bg hover:!text-black"
                />
                <TransferOwnership disabled={!viewManager.superAdmin} />
                {buttons
                    .filter(
                        (btn) =>
                            viewManager.selectedMenu !== 1 &&
                            !(
                                btn.id === '7' && viewManager.selectedMenu === 3
                            ) &&
                            !(
                                btn.id === '8' && viewManager.selectedMenu !== 3
                            ) &&
                            !(
                                btn.id === '9' && viewManager.selectedMenu === 3
                            ) &&
                            !(
                                btn.id === '10' &&
                                viewManager.selectedMenu !== 2
                            ),
                    )
                    .map(({ id, tooltip, onClick, icon }) => {
                        const isActive = getActiveTooltip(id);

                        return (
                            <Tooltip
                                key={id}
                                title={
                                    <span className="text-black">
                                        {tooltip}
                                    </span>
                                }
                                placement="bottom"
                                color="white">
                                <button
                                    style={getButtonStyles(isActive)}
                                    className="flex justify-center items-center h-10 w-10 rounded-full"
                                    onClick={onClick}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            '#F46147';
                                        e.currentTarget.style.color = '#fff';
                                    }}
                                    onMouseLeave={(e) => {
                                        Object.assign(
                                            e.currentTarget.style,
                                            getButtonStyles(isActive),
                                        );
                                    }}>
                                    {icon}
                                </button>
                            </Tooltip>
                        );
                    })}
            </div>
            <PageMangerModel open={isOpen} onClose={() => setIsOpen(false)} />
        </>
    );
});
